module.exports = __webpack_public_path__ + "assets/img/hj-two.25e57d7d.png";